export const RELOAD_GUARD_KEY = 'messenger_reload_once';

export const DEFAULT_LOAD_TIMEOUT_MS = 15000;

export interface RecoveryConfig {
  reloadGuardKey?: string;
}

export const addQuery = (url: string, q: string) => `${url}${url.includes('?') ? '&' : '?'}${q}`;

export const removeById = (id: string) => {
  const element = document.getElementById(id);
  element?.parentNode?.removeChild(element);
};

/**
 * Reloads the page exactly once per browser tab.
 *
 * Intended as a last-resort recovery mechanism when:
 * - dynamic chunks fail to load
 * - render/unmount functions are missing
 * - runtime errors prevent micro-frontend initialization
 *
 * A sessionStorage guard prevents infinite reload loops.
 */
export const safeReloadOnce = (reason: unknown, config: RecoveryConfig = {}) => {
  const guardKey = config.reloadGuardKey ?? RELOAD_GUARD_KEY;

  // eslint-disable-next-line no-console
  console.log('Messenger reload once. reason:', reason);

  if (sessionStorage.getItem(guardKey)) return;

  sessionStorage.setItem(guardKey, '1');
  window.location.reload();
};
